import Language from '@/entities/Language.js'

const language = (function(){
	return Language.getInstance();
})();
export default language;